<template>
  <div class="mob-remove-table-fixed">
    <Modal title="搜索SQL" v-model="searchSqlModal" fullscreen>
      <Row>
        <Col :md="18">
          <Input v-model="searchSql" style="margin-right: 8px" placeholder="请输入要搜索的SQL" search enter-button @on-search="startSearchSql()"/>
        </Col>
      </Row>
      <Table
        style="margin-top: 10px"
        border
        highlight-row
        :loading="searchSqlSubmitting"
        ref="searchSqlTable"
        :data="searchSqlTable.data"
        :columns="searchSqlTable.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ searchSqlTable.data.length }} 条记录，总共 {{ searchSqlTable.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="searchSqlTable.count"
            :current="searchSqlTable.page"
            :page-size="searchSqlTable.size"
            @on-change="startSearchSql"></page>
        </div>
      </div>
      <div slot="footer">
        <Button @click="searchSqlModal = false">关闭</Button>
      </div>
    </Modal>
    <Card shadow>
      <Row>
        <Col style="text-align: left" :md="12">
          <Form inline style="min-height: 41px">
            <FormItem label="需要我审批的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_approval" @on-change="tableSearchForm.need_i_execute=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
            <FormItem label="需要我执行的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_execute" @on-change="tableSearchForm.need_i_approval=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
          </Form>
        </Col>
        <Col style="text-align: right;" :md="12">
          <Button
            style="margin-bottom: 10px"
            @click="searchSqlModal = true"
            type="primary"
            icon="md-search">搜索SQL</Button>
          <Button
            style="margin-left: 10px; margin-bottom: 10px"
            @click="$router.push({ name: 'dbReleaseFlowApplyNewUser' })"
            type="primary"
            icon="md-person-add">新建用户</Button>
          <Button
            style="margin-left: 10px; margin-bottom: 10px"
            @click="$router.push({ name: 'dbReleaseFlowApplyPrivilege' })"
            type="primary"
            icon="md-add-circle">添加授权</Button>
          <Button
            style="margin-left: 10px; margin-bottom: 10px"
            @click="$router.push({ name: 'dbReleaseFlowApplySql' })"
            type="primary"
            icon="md-play">执行SQL</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent style="float: left">
          <FormItem label="申请ID">
            <InputNumber v-model="tableSearchForm.id" placeholder="" class="mob-w-100" style="min-width: 100px"/>
          </FormItem>
          <FormItem label="实例">
            <Input v-model="tableSearchForm.instance_name" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="申请类型">
            <Select v-model="tableSearchForm.application_type" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option :value="1">申请权限</Option>
              <Option :value="2">新建用户</Option>
              <Option :value="3">执行SQL</Option>
            </Select>
          </FormItem>
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.applicant" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.application_time"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange"
                        class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getDbReleaseFlow, deleteDbReleaseFlow } from '@/api/workflow/db_release_flow'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
export default {
  name: 'list',
  data () {
    return {
      tableLoading: false,
      listError: false,
      table: {
        data: [],
        columns: [
          {
            title: '申请ID',
            key: 'id',
            align: 'center',
            tooltip: true,
            width: 80
          },
          {
            title: '申请类型',
            key: 'application_type_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '实例',
            key: 'instance_id',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.instance_name ? params.row.instance_name : params.row.instance_id)
            }
          },
          {
            title: '执行SQL',
            key: 'execute_sql',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '项目',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '申请说明',
            key: 'application_content',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', {
                domProps: {
                  innerHTML: params.row.application_content
                }
              })
            }
          },
          {
            title: '申请时间',
            key: 'application_time',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.application_time) {
                return h('span', moment(params.row.application_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '执行时间',
            key: 'execute_time',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.execute_time) {
                return h('span', moment(params.row.execute_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.execute_status === 2 || params.row.execute_status === 3) {
                return h('Tag', {
                  props: {
                    color: params.row.execute_status === 2 ? 'green' : 'red'
                  }
                }, params.row.execute_status === 2 ? '执行成功' : '执行失败')
              } else if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '已执行' ? 'green'
                      : params.row.status_verbose === '驳回' ? 'red'
                        : params.row.status_verbose === '执行中' ? 'orange'
                          : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'dbReleaseFlowDetail', params: { id: params.row.id }, query: { lastPage: this.table.page }})
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.status === 1 && (this.$store.state.user.superuser || this.$store.state.user.userId === params.row.applicant.id) ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      tableSearchForm: {
        id: null,
        applicant: '',
        instance_name: '',
        application_type: '',
        application_time: '',
        application_time_after: '',
        application_time_before: '',
        need_i_approval: false,
        need_i_execute: false
      },
      userList: [],
      moment: moment,

      // search sql
      searchSqlModal: false,
      searchSql: '',
      searchSqlSubmitting: false,
      searchSqlTable: {
        data: [],
        columns: [
          {
            title: '申请ID',
            key: 'id',
            align: 'left',
            tooltip: true,
            width: 80
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'left',
            tooltip: true,
            width: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '申请时间',
            key: 'application_time',
            align: 'left',
            tooltip: true,
            width: 150,
            render: (h, params) => {
              if (params.row.application_time) {
                return h('span', moment(params.row.application_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: 'SQL',
            key: 'execute_sql',
            align: 'left',
            minWidth: 100
          }
        ],
        count: 0,
        page: 1,
        size: 13
      }
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getAllUserData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getDbReleaseFlow(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteDbReleaseFlow(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        id: null,
        applicant: '',
        instance_name: '',
        application_type: '',
        application_time: '',
        application_time_after: '',
        application_time_before: '',
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_execute: this.tableSearchForm.need_i_execute
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    // 搜索SQL
    startSearchSql (value = 1) {
      if (!this.searchSql) {
        this.$Notice.error({title: '请填写要搜索的SQL'})
        return
      }
      this.searchSqlTable.page = value
      this.searchSqlSubmitting = true
      let reqData = {
        size: this.searchSqlTable.size,
        page: this.searchSqlTable.page,
        execute_sql: this.searchSql
      }
      getDbReleaseFlow(reqData).then(res => {
        let result = res.data
        this.searchSqlTable.data = result.results
        this.searchSqlTable.count = result.count
        this.searchSqlSubmitting = false
      }).catch(res => {
        this.searchSqlSubmitting = false
        console.log(res.response)
      })
    },
    searchApplicationTimeChange (value) {
      this.tableSearchForm.application_time_after = value[0]
      this.tableSearchForm.application_time_before = value[1]
    }
  }
}
</script>

<style>
  .primary_title {
    background-color: yellow;
  }
</style>
